import { useEffect, useRef } from 'react';
import { useSearchParams } from 'react-router-dom';
import { MAGIC_UPLOAD } from '../../../common/MagicUpload/Utils/MagicUploadConstants';

/**
 * MU-routed tabs only (RECUR-28067 review fix): babler/mnemosyne/aica already create the
 * document row when Magic Upload handles a tab's upload, so the FE never persists the
 * document itself — it only needs to know when to re-fetch the tab's own data (statement
 * list + green tick, etc.) once the drawer closes. `magicUpload` search param going
 * true -> absent while the tab is mounted is the simplest reliable "drawer closed" signal
 * available (toggleDrawer deletes the param on close); the legacy (MU-off) upload path is
 * untouched.
 *
 * Extracted out of BankAccounts (RECUR-28067 review) so every MU-routed UploadJourney tab
 * can reuse the same drawer-close refresh instead of copying the ref + effect.
 */
const useRefetchOnMagicUploadClose = (fetchOnboardingData: () => void, enabled: boolean): void => {
    const [searchParams] = useSearchParams();
    const isMagicUploadDrawerOpen = searchParams.get(MAGIC_UPLOAD) === 'true';
    const wasMagicUploadDrawerOpenRef = useRef(false);

    useEffect(() => {
        if (wasMagicUploadDrawerOpenRef.current && !isMagicUploadDrawerOpen && enabled) {
            fetchOnboardingData();
        }
        wasMagicUploadDrawerOpenRef.current = isMagicUploadDrawerOpen;
    }, [isMagicUploadDrawerOpen, enabled, fetchOnboardingData]);
};

export default useRefetchOnMagicUploadClose;
